import { createContext } from 'react';

import { PageId } from '../../apis';

export interface CurrentPageView {
  pageId: PageId | null;
  pageViewId: string | null;
}

export interface PageTrackingContextValue {
  currentPageView: CurrentPageView;
  setPageView: (pageId: PageId, pageViewId: string) => void;
}

const noop = () => {};

export const PageTrackingContext = createContext<PageTrackingContextValue>({
  currentPageView: { pageId: null, pageViewId: null },
  setPageView: noop,
});
